import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-asphalt text-cab font-mono text-sm">
        Loading WebCabz…
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (role === "super_admin" && user.role !== "super_admin") {
    return <Navigate to="/app/dashboard" replace />;
  }
  if (role === "tenant" && user.role === "super_admin") {
    return <Navigate to="/admin/dashboard" replace />;
  }
  return children;
}
